/**
 * Trajetória didática da carga solta do banco traseiro: voa até a face de trás do encosto, bate
 * nele e o empurra para a frente. A carga nunca passa da face do encosto.
 */
export const ENCOSTO = {
  pivoY: 0.52,
  /** face de trás do encosto sem deformação, no eixo longitudinal do carro */
  faceTrasZ: -0.28,
  inclinacaoMax: 0.08,
} as const
/** meia profundidade da carga, contando o bolso virado para o banco */
export const FRENTE_CARGA = 0.0965
const PARTIDA = { x: -0.18, y: 0.98, z: -0.67 }
const FIM_VOO = 0.7

const limitar01 = (v: number) => Math.max(0, Math.min(1, Number.isFinite(v) ? v : 0))
const suave = (p: number) => p * p * (3 - 2 * p)

export function movimentoCargaEncosto(progresso: number) {
  const p = limitar01(progresso)
  const voo = suave(limitar01(p / FIM_VOO)), contato = suave(limitar01((p - FIM_VOO) / (1 - FIM_VOO)))
  const inclinacaoEncosto = ENCOSTO.inclinacaoMax * contato
  const x = PARTIDA.x + voo * 0.18, y = PARTIDA.y + voo * 0.11
  const zContatoInicial = ENCOSTO.faceTrasZ - FRENTE_CARGA
  const z = PARTIDA.z + (zContatoInicial - PARTIDA.z) * voo + (y - ENCOSTO.pivoY) * Math.sin(inclinacaoEncosto)
  // Gira em voo e chega plana: a face da carga acompanha o encosto no contato.
  const rotacaoX = -0.25 * Math.sin(Math.PI * voo) + inclinacaoEncosto
  return { x, y, z, rotacaoX, rotacaoZ: 0.1 * Math.sin(Math.PI * voo), inclinacaoEncosto }
}
